// @ts-nocheck
import productAlternatePackagingReducer, {
    GreifDataAlternatePackagingActions,
} from "@store/Framework/Store/Greif/Data/ProductAlternatePackaging/ProductAlternatePackagingReducer";
import shipmentsReducer, {
    GreifDataShipmentsActions,
} from "@store/Framework/Store/Greif/Data/Shipments/ShipmentsReducer";
import shipmentStatusesReducer, {
    GreifDataShipmentStatusesActions,
} from "@store/Framework/Store/Greif/Data/ShipmentStatuses/ShipmentStatusesReducer";
import taxExemptionCertificatesReducer, {
    GreifDataTaxExemptionCertificatesActions,
} from "@store/Framework/Store/Greif/Data/TaxExemptionCertificates/TaxExemptionCertificatesReducer";
import tecFinanceCompaniesReducer, {
    GreifDataTECFinanceCompaniesActions,
} from "@store/Framework/Store/Greif/Data/TECFinanceCompanies/TECFinanceCompaniesReducer";
import tecMessagesReducer, {
    GreifDataTECMessagesActions,
} from "@store/Framework/Store/Greif/Data/TECMessages/TECMessagesReducer";
import { combineReducers } from "redux";

const dataReducers = {
    taxExemptionCertificates: taxExemptionCertificatesReducer,
    tecFinanceCompanies: tecFinanceCompaniesReducer,
    tecMessages: tecMessagesReducer,
    productAlternatePackaging: productAlternatePackagingReducer,
    shipments: shipmentsReducer,
    shipmentStatuses: shipmentStatusesReducer,
};

export type GreifDataActions =
    | GreifDataTaxExemptionCertificatesActions
    | GreifDataTECFinanceCompaniesActions
    | GreifDataTECMessagesActions
    | GreifDataAlternatePackagingActions
    | GreifDataShipmentsActions
    | GreifDataShipmentStatusesActions;
export default combineReducers(dataReducers);
